import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShellComponent } from './modules/global/components/shell/shell.component';
import { NotFoundComponent } from './modules/global/components/errors/notfound/notfound.component';
import { TabsComponent } from './modules/global/components/tabs/tabs.component';
import { UnauthorizedComponent } from './modules/global/components/errors/unauthorized/unauthorized.component';
import { InternalServerErrorComponent } from './modules/global/components/errors/internal-server-error/internal-server-error.component';
import { AuthGuard } from './modules/global/guards/auth.guard';
import { MsalCustomGuard } from './modules/global/guards/msalcustom.guard';
import { ReportsComponent } from './modules/global/components/reports/reports.component';
import { MarginCalculatorListComponent } from './modules/margin-calculator/components/list/list.component';
import { GridDataComponent } from './modules/margin-calculator/components/grid-data/grid-data.component';
import { HelpComponent } from './modules/global/components/help/help.component';
import { MarginCostUploadViewComponent } from './modules/margin-cost-upload/components/view/view.component';
const routes: Routes = [
    {
        path: '',
        component: ShellComponent,
        canActivate : [MsalCustomGuard],
        children: [
            {
                path: 'tabs',
                component: TabsComponent,
                canActivate: [AuthGuard],
                children: [
                    {
                        path: 'gross-margin-summary',
                        loadChildren: () => import('./modules/tabs/margin-summary/margin-summary.module').then(m => m.MarginSummaryModule)
                    },
                    {
                        path: 'drive-update',
                        loadChildren: () => import('./modules/tabs/drive-update/drive-update.module').then(m => m.DriveUpdateModule)
                    },
                    {
                        path: 'drive-plan',
                        loadChildren: () => import('./modules/tabs/drive-plan/drive-plan.module').then(m => m.DrivePlanModule)
                    },
                    {
                        path: 'pyramid-structure',
                        loadChildren: () => import('./modules/tabs/pyramid-structure/pyramid-structure.module')
                            .then(m => m.PyramidStructureModule)
                    },
                    {
                        path: 'employee-data',
                        loadChildren: () => import('./modules/tabs/employee-data/employee-data.module').then(m => m.EmployeeDataModule)
                    },
                    {
                        path: 'target-report',
                        loadChildren: () => import('./modules/tabs/target-report/target-report.module').then(m => m.TargetReportModule)
                    },
                    {
                        path: 'engineering-plan',
                        loadChildren: () => import('./modules/tabs/engineering-plan/engineering-plan.module')
                            .then(m => m.EngineeringPlanModule)
                    },
                    {
                        path: '',
                        redirectTo: '/tabs/gross-margin-summary',
                        pathMatch: 'full'
                    },
                ]
            },

            {
                path: 'reports',
                component: ReportsComponent,
                canActivate: [AuthGuard],
                children: [
                    {
                        path: 'overall-status-report',
                        loadChildren: () => import('./modules/reports/overall-status-report/overall-status-report.module').then
                        (m => m.OverallStatusReportModule)
                    },
                    {
                        path: 'delay-report',
                        loadChildren: () => import('./modules/reports/delay-report/delay-report.module').then(m => m.DelayReportModule)
                    },
                    {
                        path: 'aoa-effectiveness-report',
                        loadChildren: () => import('./modules/reports/aoa-effectiveness-report/aoa-effectiveness-report.module').then
                        (m => m.AoaEffectivenessReportModule)
                    },
                    {
                        path: 'client-performance-report',
                        loadChildren: () => import('./modules/reports/client-performance-report/client-performance-report.module').then
                        (m => m.ClientPerformanceReportModule)
                    },
                    {
                        path: 'pit-target-report',
                        loadChildren: () => import('./modules/reports/pit-target-report/pit-target-report.module').then
                        (m => m.PITTargetReportModule)
                    },
                    {
                        path: 'actionitem-saving-report',
                        loadChildren: () => import('./modules/reports/actionitem-saving-report/actionitem-saving-report.module').then
                        (m => m.ActionitemSavingReportModule)
                    },
                    {
                        path: 'application-usage-report',
                        loadChildren: () => import('./modules/reports/application-usage-report/application-usage-report.module').then
                        (m => m.ApplicationUsageReportModule)
                    },
                    {
                        path: 'app-usage-summary-report',
                        loadChildren: () => import('./modules/reports/app-usage-summary-report/app-usage-summary-report.module').then
                        (m => m.AppUsageSummaryReportModule)
                    },
                    {
                        path: 'project-level-report',
                        loadChildren: () => import('./modules/reports/project-level-target-report/project-level-target-report.module').then
                        (m => m.ProjectLevelTargetReportModule)
                    },
                    {
                        path: 'automate-user-access-report',
                        loadChildren: () => import('./modules/reports/automate-user-access-report/automate-user-access-report.module').then
                        (m => m.AutomateUserAccessReportModule)
                    },
                    {
                        path: '',
                        redirectTo: '/reports/overall-status-report',
                        pathMatch: 'full'
                    },
                ]
            },
            {
                path: 'margin-calcuator',
                component: MarginCalculatorListComponent,
                canActivate: [AuthGuard],
            },
            {
                path: 'margin-cost-upload',
                component: MarginCostUploadViewComponent,
                canActivate: [AuthGuard],
            },
            {
                path: 'grid-data',
                component: GridDataComponent,
                canActivate: [AuthGuard],
            },
            // {
            //     path: 'sid',
            //     component: NotFoundComponent,
            //     canActivate: [AuthGuard],
            //     children: [
            //         {
            //             path: 'rate-card',
            //             loadChildren: () => import('./modules/sid/rate-card/rate-card.module').then
            //             (m => m.RateCardListModule)
            //         },
            //         {
            //             path: 'projects',
            //             loadChildren: () => import('./modules/sid/projects/projects.module').then(m => m.ProjectsModule)
            //         },
            //         {
            //             path: 'reports',
            //             loadChildren: () => import('./modules/sid/reports/reports.module').then(m => m.ReportsModule)
            //         },
            //         {
            //             path: 'sold-vs-staffed',
            //             loadChildren: () => import('./modules/sid/sold-vs-staffed/sold-vs-staffed.module').then(m => m.SoldVsStaffedModule)
            //         },
            //         {
            //             path: '',
            //             redirectTo: '/sid/projects',
            //             pathMatch: 'full'
            //         }
            //     ]
            // },
            {
                path: 'help',
                component: HelpComponent
            },
            {
                path: '',
                redirectTo: '/tabs/gross-margin-summary',
                pathMatch: 'full'
            },
            {
                path: 'unauthorized',
                component: UnauthorizedComponent
            },
            {
                path: 'error',
                component: InternalServerErrorComponent
            },
            {
                path: 'notfound',
                component: NotFoundComponent
            },
            {
                path: '**',
                component: NotFoundComponent
            }
        ],
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
